__turbopack_context__.v({
  "card": "press-card-module-scss-module__SriXsG__card",
  "titleLink": "press-card-module-scss-module__SriXsG__titleLink",
});
